<template>
  <div v-if="themeDone" class="layout" :class="{'layout_full-height': isLoginPage || isRegisterPage}" id="app">

    <Icons :iconsContext="iconsContext"></Icons>
    <Layout v-if="useLayout" :type="layoutType" :banners="banners">
      <MobileAppBanner
        :scountImg="scountImg"
        :state="isBannerMobile"
        @hide="onCloseBanner"
        @action="installMobileModalOpen"
      />
      <div v-if="!isMobileApp" class="header-container" id="appHeaderContainer">
        <Header
          :logo="headerPropsLogo"
          logoAlt="Scount"
          :profile="{ avatarUrl: avatar ? avatar : headerAvatar, link: '/dashboard', name: firstName }"
          :menu="headerProps.menu"
          :menuHidden="headerProps.menuHidden"
          :mobileMenu="headerProps.mobileMenu"
          :state="isAuthenticated ? 'authorized' : 'unauthorized'"
          :notifications="[]"
          :coins="balance ? balance.amount : 0"
          :backText="backText"
          @open-notifications="onNotifications"
          @open-wallet="onWallet"
          @back="onBack"
        ></Header>
      </div>

      <router-view
        :style="{
          'flex': '1 1 auto',
          'min-height': '0',
        }"
      />
      <Footer
        v-if="!isMobileApp"
        id="appFooterContainer"
        copyright="ВФЛА"
        :links="footerLinks"
        :socials="footerSocials"
        :languages="[
          { id: 'ru', text: 'Русский', current: true },
        ]"
        :feedback="footerFeedback"
        @feedback="onFeedback"
      ></Footer>
    </Layout>

    <router-view v-if="!useLayout" />

    <Wallet
      :active="walletActive"
      :localizedText="{
        title: 'Мой кошелёк',
        buy: 'Что купить?',
      }"
      :coins="balance ? balance.amount : 0"
      :days="walletOperations"
      @close="walletActive = false"
      @buy="onBuy"
    ></Wallet>

     <Onboarding></Onboarding>
     <!-- :subtitle="`Получено ${ achievements.length } / ${ achievementsAll.length }`" -->

     <Modal
      :active="installMobileModal"
      name="installMobileModal"
      title="Установите мобильное приложение БегунДА"
      :subtitle="`Ваш код спортивной программы: <span>${ code ?code.code : '' }</span>`"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="installMobileModal = false"
      :img="scountImg"
    >
      <div class="modal-qrcode">
        <img
          v-if="installMobileQrCode"
          class="modal-qrcode__img"
          :src="installMobileQrCode"
          alt="QR-код для скачивания приложения БегунДА"
        />
        <p v-if="installMobileQrCode" class="modal-qrcode__text">
          Наведите камеру и скачайте приложение БегунДА
        </p>
        <div class="modal-qrcode__items">
          <a v-if="OS === 'unknown'" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" target="_blank" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="appstoreImg" alt="" />
          </a>
          <a v-if="OS === 'unknown'" target="_blank"  href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="googleplayImg" alt="" />
          </a>
          <a v-if="OS === 'unknown'" target="_blank"  href="https://www.rustore.ru/catalog/app/pro.scount.app" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="rustoreImg" alt="" />
          </a>
          <a v-if="OS === 'iOS'" target="_blank" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="appstoreImg" alt="" />
          </a>
          <a v-if="OS === 'Android'" target="_blank"  href="https://www.rustore.ru/catalog/app/pro.scount.app" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="rustoreImg" alt="" />
          </a>
          <a v-if="OS === 'Android'" target="_blank"  href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1" class="modal-qrcode__item">
            <img class="modal-qrcode__item-img" :src="googleplayImg" alt="" />
          </a>
        </div>
        <ul class="modal-qrcode__list">
          <li class="modal-qrcode__list-item">
            <Icon name="steps"></Icon>
            <div class="modal-qrcode__list-body">
              <span>Подключите шагомер</span> и получайте баллы <img :src="coinImg"/> за каждую 1 000 шагов
            </div>
          </li>
          <li class="modal-qrcode__list-item">
            <Icon name="stopwatch"></Icon>
            <div class="modal-qrcode__list-body">
              <span>Используйте встроенный трекер</span> без необходимости подключать сторонние приложения и гаджеты
            </div>
          </li>
          <li class="modal-qrcode__list-item">
            <Icon name="bell"></Icon>
            <div class="modal-qrcode__list-body">
              <span>Получайте пуш-уведомления</span> и не пропускайте важные события и розыгрыши
            </div>
          </li>
        </ul>
      </div>
    </Modal>

    <Modal
      :active="mobileMigrationModal"
      name="mobileMigrationModal"
      :closable="false"
      class="mobile-migration-modal"
    >
      <div class="mobile-migration">
        <img class="mobile-migration__logo" :src="scountImg" alt="">
        <h2 class="mobile-migration__title">
          Все функции теперь<br>
          в мобильном приложении
        </h2>
        <p class="mobile-migration__subtitle">Стало удобнее и быстрее 🚀</p>
        <div class="mobile-migration__bonus">
          +500 <img :src="coinImg" alt=""> за установку
        </div>
        <button
          class="mobile-migration__button"
          type="button"
          @click="onMobileMigrationInstall"
        >
          Установить приложение
        </button>
        <button
          class="mobile-migration__skip"
          type="button"
          @click="onMobileMigrationSkip"
        >
          Продолжить в вебе<br>
          (старая версия)
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { Base64 } from 'js-base64';
import QRCode from 'qrcode';
import Icons from '@rr-component-library/icons/src/main';
import Layout from '@sc-component-library/layout/src/main';
import Header from '@sc-component-library/header/src/main';
import Wallet from '@sc-component-library/wallet/src/main';
import Footer from '@sc-component-library/footer/src/main';
import Onboarding from '@/components/Onboarding/Onboarding.vue';
import { scrollToId } from '@/assets/js/helpers';
import Avatars from '@/assets/data/avatars';
import ScountImgMiddle from '@/assets/img/scount-middle.svg';
import RustoreImg from '@/assets/img/rustore.jpg';
import AppstoreImg from '@/assets/img/appstore.jpg';
import GoogleplayImg from '@/assets/img/google-play.jpg';
import CoinImg from '@/assets/img/coin.svg';
import UpdatedIcon from '@/assets/icons/updated.svg';
import MobileAppBanner from '@/components/MobileAppBanner/MobileAppBanner.vue';

const MOBILE_MIGRATION_MODAL_STORAGE_KEY = 'mobileMigrationModalHiddenUntil';
const MOBILE_MIGRATION_MODAL_REPEAT_DAYS = 7;

export default {
  name: 'App',
  components: {
    Icons,
    Layout,
    Header,
    Wallet,
    Footer,
    Onboarding,
    MobileAppBanner,
  },
  data() {
    return {
      iconsContext: require.context(
        '!svg-inline-loader?'
        + 'removeTags=true&removeSVGTagAttrs=true&removingTagAttrs=fill'
        + '!../src/assets/icons',
        false,
        /\w+\.svg$/i,
      ),
      walletOperations: [],
      walletActive: false,
      avatar: '',
      firstName: '',
      stepImage: '',
      footerFeedback: null,
      scountImg: ScountImgMiddle,
      rustoreImg: RustoreImg,
      appstoreImg: AppstoreImg,
      googleplayImg: GoogleplayImg,
      coinImg: CoinImg,
      installMobileModal: false,
      installMobileQrCode: '',
      mobileMigrationModal: false,
      isBannerMobile: false,
    };
  },
  computed: {
    ...mapGetters('settings', ['theme', 'themeDone', 'options', 'resources', 'checkAppUrl']),
    ...mapGetters('user', ['profile', 'isAuthenticated', 'questionnaire', 'questionnaireStatus', 'isMobileApp', 'hasParticipantActiveDeviceSession', 'hasParticipantActiveDeviceSessionToFirstJune', 'code', 'needsConsent', 'emptyProfile']),
    ...mapGetters('wallet', ['balance', 'operations']),
    ...mapGetters('operations', ['searchEventsData']),
    ...mapGetters('content', ['rule', 'introSections', 'articles']),
    isNotPage() {
      return this.$route.name !== 'Home' && this.$route.name !== 'Login' && this.$route.name !== 'Register' && this.$route.name !== 'RegisterComplete' && this.$route.name !== 'Auth' && this.$route.name !== 'AuthConfirm' && this.$route.name !== 'AuthSSO' && this.$route.name !== 'AuthComplete' && this.$route.name !== 'AuthSSOComplete' && this.$route.name !== 'Support';
    },
    isSpecialSettingsMp() {
      return this.options ? this.options.isSpecialSettingsMp === true : false;
    },
    OS() {
      const userAgent = navigator.userAgent || navigator.vendor || (window).opera;
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }
      return 'unknown';
    },
    isMobileOS() {
      return this.OS !== 'unknown';
    },
    setCookieFromMobileApp() {
      return this.$route.query.setCookieFromMobileApp === 'true';
    },
    marketingProgramCode() {
      return this.$route.query.code;
    },
    useLayout() {
      return !this.isLoginPage && !this.isRegisterPage && !this.isTeamPage && !this.isTeamCreatePage;
    },
    layoutType() {
      return !this.isInternalPage && this.$route.name !== 'Home' ? 'general' : 'banners';
    },
    headerProps() {
      return {
        menu: [
          {
            text: 'Задания',
            action: () => { this.onAction('tasks'); },
          },
          {
            text: 'Маркет',
            action: () => { this.onAction('market'); },
          },
          {
            text: 'Рейтинг',
            action: () => { this.onAction('rating'); },
          },
          {
            text: this.menuUnauthorizedReglamentName || 'Регламент',
            action: this.supportReglament,
            target: '_blank',
          },
        ],
        menuHidden: [
          // {
          //   text: 'Школа ЗОЖ',
          //   action: this.menuUnauthorizedVK,
          //   target: '_blank',
          //   external: true,
          // },
          {
            text: 'Кабинет участника',
            action: () => this.installMobileModalOpen(),
          },
          {
            text: 'Поддержка',
            action: () => this.$router.push({ name: 'Support' }).catch(() => {}),
          },
        ],
        mobileMenu: [
          {
            text: 'Задания',
            action: () => { this.onAction('tasks'); },
          },
          {
            text: 'Маркет',
            action: () => { this.onAction('market'); },
          },
          {
            text: 'Рейтинг',
            action: () => { this.onAction('rating'); },
          },
          {
            text: this.menuUnauthorizedReglamentName || 'Правила',
            action: this.supportReglament,
            target: '_blank',
          },
          {
            text: 'Партнёры',
            action: () => { this.onAction('partners'); },
          },
          {
            divider: true,
          },
          {
            text: 'Школа ЗОЖ',
            action: this.menuUnauthorizedVK,
            target: '_blank',
            external: true,
          },
          {
            text: 'Поддержка',
            action: () => this.$router.push({ name: 'Support' }).catch(() => {}),
          },
          {
            divider: true,
          },
          {
            text: `<img class="mobile-menu-store" src="${AppstoreImg}" alt="Загрузите в App Store">`,
            action: 'https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298',
            target: '_blank',
            hidden: this.OS === 'Android',
          },
          {
            text: `<img class="mobile-menu-store" src="${GoogleplayImg}" alt="Доступно в Google Play">`,
            action: 'https://play.google.com/store/apps/details?id=pro.scount.app&pli=1',
            target: '_blank',
            hidden: this.OS === 'iOS',
          },
          {
            text: `<img class="mobile-menu-store" src="${RustoreImg}" alt="Доступно в RuStore">`,
            action: 'https://www.rustore.ru/catalog/app/pro.scount.app',
            target: '_blank',
            hidden: this.OS === 'iOS',
          },
        ],
      };
    },
    banners() {
      return this.resources ? this.resources.banners || null : null;
    },
    headerPropsLogo() {
      return this.resources ? this.resources.logo || '' : '';
    },
    headerAvatar() {
      return this.resources ? this.resources.headerAvatar || '' : '';
    },
    footerLinks() {
      if (!this.resources) {
        return [];
      }
      const rule = {
        text: 'Правила',
        href: this.supportReglament,
      };
      const updatedFooterLinks = [...this.resources.footerLinks];
      updatedFooterLinks.splice(1, 0, rule);
      return updatedFooterLinks;
    },
    footerSocials() {
      return this.resources ? this.resources.footerSocials || [] : [];
    },
    supportVK() {
      return this.resources ? this.resources.supportVK || '#' : '#';
    },
    menuUnauthorizedVK() {
      return this.resources ? this.resources.menuUnauthorizedVK || '#' : '#';
    },
    menuUnauthorizedReglamentName() {
      return this.resources ? this.resources.menuUnauthorizedReglamentName || '' : '';
    },
    supportReglament() {
      return this.rule ? this.rule.url : '#';
    },
    mobileAppLink() {
      return this.resources && this.resources.mobileAppLink
        ? this.resources.mobileAppLink
        : '';
    },
    menuAboutTitleMobile() {
      return this.resources ? this.resources.menuAboutTitleMobile || '' : '';
    },
    isTeamsEnabled() {
      return this.options ? this.options.isTeamsEnabled === true : false;
    },
    isTeamStepRequired() {
      return this.options ? this.options.isTeamStepRequired === true : false;
    },
    isFeedbackEnabled() {
      return this.options ? this.options.isFeedbackEnabled === true : false;
    },
    isTeamSet() {
      return this.profile ? this.profile.teams !== undefined && this.profile.teams.length > 0 : false;
    },
    isLoginPage() {
      return this.$route.name === 'Auth' || this.$route.name === 'AuthConfirm' || this.$route.name === 'AuthSSO';
    },
    isRegisterPage() {
      return this.$route.name === 'Register' || this.$route.name === 'RegisterComplete';
    },
    isTeamPage() {
      return this.$route.name === 'Team';
    },
    isTeamCreatePage() {
      return this.$route.name === 'TeamCreate';
    },
    isInternalPage() {
      return !['Home', 'Auth', 'AuthConfirm', 'AuthSSO', 'Register', 'RegisterComplete', 'Team', 'TeamCreate'].includes(this.$route.name);
    },
    routeName() {
      return this.$route.name;
    },
    backText() {
      const names = {
        Dashboard: this.isClubEnabled ? 'Моя страница' : null,
        Tasks: 'Задания',
        TasksAvailable: 'Задания',
        TasksInProgress: 'Задания',
        TasksCompleted: 'Задания',
        Nominations: 'Рейтинг',
        NominationsInProgress: 'Рейтинг',
        NominationsAvailable: 'Рейтинг',
        NominationsCompleted: 'Рейтинг',
        Activities: 'Активность',
        Settings: 'Мой аккаунт',
        SettingsProfile: 'Мой аккаунт',
        SettingsTrainings: 'Мой аккаунт',
        SettingsTrackers: 'Мой аккаунт',
        SettingsHistory: 'Мой аккаунт',
        Market: 'Маркет',
        RewardDetails: 'Маркет',
        Community: 'Школа ЗОЖ',
        About: this.menuAboutTitleMobile ? this.menuAboutTitleMobile : 'О чемпионате',
        Support: 'Поддержка',
        MyTeam: 'Команда',
        Participants: 'Участники',
        Calendar: 'Календарь',
        Club: !this.isClubEnabled ? 'Клуб' : null,
      };
      return names[this.$route.name] || '';
    },
    isStepImage() {
      return '<div class="step-image"></div>';
    },
    isClubEnabled() {
      return this.options ? this.options.isClubEnabled === true : false;
    },
    canShowMobileMigrationModal() {
      return this.isAuthenticated === true
        && !this.isMobileApp
        && this.hasParticipantActiveDeviceSession === false
        && this.hasParticipantActiveDeviceSessionToFirstJune === false
        && !this.isMobileMigrationModalPostponed();
    },
  },
  watch: {
    profile(val) {
      if (val) {
        this.avatar = this.getAvatarImage(this.profile ? this.profile.avatar : null);
        this.firstName = this.profile ? this.profile.firstName : '';
        this.getDeviceSession();
        this.getCodeMp();
        setTimeout(() => { this.processIsTeamRequired(); }, 250);

        // Если профиль загружен и нужны согласия, показываем модальное окно только на внутренних страницах (не Team)
        if (this.isAuthenticated && !this.emptyProfile && this.needsConsent && this.isInternalPage) {
          this.showConsentModal = true;
        }
        this.showMobileMigrationModalIfNeeded();
      }
    },
    themeDone(val) {
      if (val) {
        this.checkForMobile();
        this.saveDeviceId();
        this.saveTeamInvitation();
        this.processMenuItems();
        this.setBannerMobile();
        this.generateInstallMobileQrCode();
        setTimeout(() => { this.processIsTeamRequired(); }, 250);
        setTimeout(() => { this.initUserback(); }, 1000);
      }
    },
    routeName() {
      setTimeout(() => { this.processIsTeamRequired(); }, 250);
    },
    needsConsent() {
      // Логика согласий временно отключена
    },
    isAuthenticated(newVal) {
      // Если пользователь авторизовался и нужны согласия, показываем модальное окно
      if (newVal === true && this.profile && !this.emptyProfile && this.needsConsent && this.isInternalPage) {
        this.showConsentModal = true;
      }
      this.showMobileMigrationModalIfNeeded();
    },
    hasParticipantActiveDeviceSession() {
      this.showMobileMigrationModalIfNeeded();
    },
    hasParticipantActiveDeviceSessionToFirstJune() {
      this.showMobileMigrationModalIfNeeded();
    },
    mobileAppLink() {
      this.generateInstallMobileQrCode();
    },
  },
  methods: {
    ...mapActions('settings', ['loadSettings']),
    ...mapActions('operations', ['searchEvents']),
    ...mapActions('user', ['getQuestionnaire', 'setIsMobileApp', 'setDeviceId', 'hasDeviceSession', 'getCode', 'getProfile']),
    ...mapActions('content', ['getRule', 'getIntroSections', 'getArticles']),

    detectOS() {
      if (this.$root.isDesktop) {
        this.desktop = true;
      } else {
        const { platform } = window.navigator;
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        if (iosPlatforms.indexOf(platform) !== -1) {
          this.iOS = true;
          return;
        }
        this.android = true;
      }
    },

    getCodeMp() {
      if (this.profile) {
        this.getCode(this.profile.marketingProgramId);
      }
    },
    setBannerMobile() {
      if (this.isSpecialSettingsMp && this.isNotPage && this.hasParticipantActiveDeviceSession === false && !this.isMobileApp) {
        this.isBannerMobile = true;
        this.$nextTick(() => {
          this.onResize();
        });
      }
    },
    onCloseBanner() {
      this.isBannerMobile = false;
      this.$nextTick(() => {
        this.onResize();
      });
    },
    installMobileModalOpen() {
      this.installMobileModal = true;
    },
    generateInstallMobileQrCode() {
      if (!this.mobileAppLink) {
        this.installMobileQrCode = '';
        return;
      }
      const { mobileAppLink } = this;
      QRCode.toDataURL(mobileAppLink, {
        width: 196,
        margin: 0,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      })
        .then((qrCode) => {
          if (mobileAppLink !== this.mobileAppLink) return;
          this.installMobileQrCode = qrCode;
        })
        .catch(() => {
          this.installMobileQrCode = '';
        });
    },
    onMobileMigrationInstall() {
      this.postponeMobileMigrationModal();
      this.mobileMigrationModal = false;
      this.installMobileModalOpen();
    },
    onMobileMigrationSkip() {
      this.postponeMobileMigrationModal();
      this.mobileMigrationModal = false;
    },
    isMobileMigrationModalPostponed() {
      const hiddenUntil = Number(localStorage.getItem(this.mobileMigrationModalStorageKey()));
      return Number.isFinite(hiddenUntil) && hiddenUntil > Date.now();
    },
    postponeMobileMigrationModal() {
      const hiddenUntil = Date.now() + MOBILE_MIGRATION_MODAL_REPEAT_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.mobileMigrationModalStorageKey(), hiddenUntil.toString());
    },
    clearMobileMigrationModalPostpone() {
      localStorage.removeItem(this.mobileMigrationModalStorageKey());
    },
    mobileMigrationModalStorageKey() {
      const participantId = this.profile && this.profile.participantId ? this.profile.participantId : 'unknown';
      return `${MOBILE_MIGRATION_MODAL_STORAGE_KEY}:${participantId}`;
    },
    showMobileMigrationModalIfNeeded() {
      if (this.hasParticipantActiveDeviceSession === true) {
        this.clearMobileMigrationModalPostpone();
      }
      this.mobileMigrationModal = this.canShowMobileMigrationModal;
    },
    changeLang(id) {
      localStorage.setItem('language', id);
      window.location.reload();
    },
    newLink() {
      return this.resources.footerLinks.push(this.rule);
    },
    onAction(page) {
      if (this.$route.name !== 'Home') {
        window.location.href = `${window.location.origin}/#${page}`;
        return;
      }
      scrollToId(page, true);
    },
    onNotifications() {
      console.log('notifications');
    },
    getMetadataValue(metadata, name) {
      const item = metadata.find((m) => m.name === name);
      return item ? item.value : null;
    },
    getOperationType(event) {
      const tag = event.tags.find((t) => t.key === 'OperationType');
      return tag ? tag.value : null;
    },
    convertEventToOperation(event) {
      const operationType = this.getOperationType(event);
      const attributes = {};
      event.metadata.forEach((meta) => {
        attributes[meta.name] = meta.value;
      });

      // Добавляем данные из objects (для заданий и других сущностей)
      if (event.objects && event.objects.length > 0) {
        event.objects.forEach((obj) => {
          if (obj.metadata) {
            obj.metadata.forEach((meta) => {
              // Добавляем, только если ещё нет в attributes
              if (!attributes[meta.name]) {
                attributes[meta.name] = meta.value;
              }
            });
          }
        });
      }

      // Получаем ExerciseId из tags, metadata или objects
      let exerciseId = null;
      const exerciseIdTag = event.tags.find((t) => t.key === 'ExerciseId');
      if (exerciseIdTag) {
        exerciseId = exerciseIdTag.value;
      } else {
        // Пробуем найти в metadata
        exerciseId = this.getMetadataValue(event.metadata, 'ExerciseId');
        // Если не нашли, пробуем получить из objects (для BalanceOperation)
        if (!exerciseId && event.objects && event.objects.length > 0) {
          const exerciseObj = event.objects.find((obj) => obj.type === 'Exercise');
          if (exerciseObj && exerciseObj.key) {
            exerciseId = exerciseObj.key;
          }
        }
      }

      return {
        operationId: event.eventId || event.operationId || null,
        operationType,
        operationDate: event.operationDate || event.eventDate,
        operationSourceId: this.getMetadataValue(event.metadata, 'OperationSourceId'),
        sourceId: exerciseId,
        attributes,
        state: 'Synchronized',
      };
    },
    onWallet() {
      if (this.profile && this.profile.participantId && this.profile.marketingProgramId) {
        this.searchEvents({
          subjectId: this.profile.participantId,
          tags: [],
          tagsQuery: '"OperationType"="BalanceOperation"',
          offset: 0,
          count: 100,
        }).then(() => {
          if (this.searchEventsData && this.searchEventsData.values) {
            const operations = this.searchEventsData.values.map((event) => this.convertEventToOperation(event));
            this.walletOperations = this.getMapppedOperations(operations);
            this.walletActive = true;
          }
        }).catch(() => {
        });
      }
    },
    onBuy() {
      this.walletActive = false;
      this.$router.push({ name: 'Market', query: this.isMobileApp ? { title: 'Маркет', addToHistory: 'true' } : {} }).catch(() => {});
    },
    onBack() {
      if (this.isClubEnabled) {
        this.$router.push({ name: 'Club', query: this.isMobileApp ? { title: 'Клуб', addToHistory: 'true' } : {} }).catch(() => {});
      } else {
        this.$router.push({ name: 'Dashboard', query: this.isMobileApp ? { addToHistory: 'true' } : {} }).catch(() => {});
      }
    },
    onResize() {
      this.$root.isMobile = window.innerWidth < 768;
      this.$root.isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
      this.$root.isDesktop = window.innerWidth >= 1200;
    },
    onFeedback() {
      if (!window.Userback) return;
      setTimeout(() => { window.Userback.open(); }, 250);
    },
    getMapppedOperations(operations) {
      if (!operations) return [];
      const days = [];
      const last = { date: '', index: 0 };
      for (let i = 0; i < operations.length; i += 1) {
        const value = operations[i];
        const day = { date: '', items: [] };
        const date = dayjs.utc(value.operationDate);
        if (date.isValid()) {
          day.date = date.format('D MMMM');
        } else {
          continue;
        }
        const item = this.getMappedItem(value);
        if (i === 0) {
          last.date = date.format('YYYY-MM-DD');
          last.index = 0;
          day.items = [item];
          days.push(day);
          continue;
        }
        if (last.date === date.format('YYYY-MM-DD')) {
          days[last.index].items.push(item);
          continue;
        }
        day.items = [item];
        days.push(day);
        last.date = date.format('YYYY-MM-DD');
        last.index = days.length - 1;
      }
      return days;
    },
    pluralizeSteps(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return `<b>${count}</b> шаг`;
      } if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        return `<b>${count}</b> шага`;
      }
      return `<b>${count}</b> шагов`;
    },
    getMappedItem(value) {
      const item = {};
      // Обработка BalanceOperation
      if (value.operationType === 'BalanceOperation') {
        const balanceOperationType = value.attributes.BalanceOperationType;
        const operationSource = value.attributes.OperationSource;

        // Покупка (списание средств)
        if (balanceOperationType === 'Withdrawal') {
          item.img = value.attributes.ProductMobileImageUrl || '';
          item.title = value.attributes.ProductName || 'Товар';
          item.type = 'Покупка за баллы';
          item.coins = -Math.round(parseFloat(value.attributes.Amount || 0));
          const promotionId = value.attributes.PromotionId || '';
          if (promotionId) {
            item.link = `/market/reward?id=${promotionId}&title=${encodeURIComponent(item.title)}`;
          } else {
            item.link = '/my-settings/purchase-history';
          }
          return item;
        }

        // Награда за задание (пополнение за выполнение задания)
        if (balanceOperationType === 'Refill' && operationSource === 'Exercise') {
          item.img = value.attributes.ExerciseMobileImageUrl || '';
          const exerciseTitle = value.attributes.ExerciseTitle || 'задание';
          item.title = exerciseTitle;
          item.type = 'Награда за задание';
          item.coins = Math.round(parseFloat(value.attributes.Amount || 0));
          const exerciseId = value.sourceId;
          const operationSourceId = value.attributes.OperationSourceId;
          if (exerciseId && operationSourceId) {
            item.link = `/tasks/completed#!showTask=${exerciseId}&peId=${operationSourceId}`;
          } else if (exerciseId) {
            item.link = `/tasks/completed#!showTask=${exerciseId}`;
          }
          return item;
        }

        // Награда за тренировку (пополнение за активность)
        if (balanceOperationType === 'Refill' && operationSource === 'Activity') {
          item.img = UpdatedIcon;
          item.isInternalImg = true;
          item.title = '<span style="color: #000000;">Награда за тренировку</span>';
          item.type = '';
          item.coins = Math.round(parseFloat(value.attributes.Amount || 0));
          return item;
        }

        // Награда за установку мобильного приложения
        if (balanceOperationType === 'Refill' && operationSource === 'MobileDevice') {
          item.img = this.avatar;
          item.title = 'Начисление баллов';
          item.type = 'Установка мобильного приложения';
          item.coins = Math.round(parseFloat(value.attributes.Amount || 0));
          return item;
        }
      }
      if (value.attributes.OperationSource === 'Registration') {
        item.img = this.avatar;
        item.title = 'Добро пожаловать';
        item.type = 'Приветственные баллы';
        item.coins = Math.round(value.attributes.Amount);
        return item;
      }
      if (value.attributes.OperationSource === 'ExtendedQuestionnaire') {
        item.img = this.avatar;
        item.title = 'Анкета участника';
        item.type = 'Награда за ответы';
        item.coins = Math.round(value.attributes.Amount);
        return item;
      }
      if (value.attributes.OperationSource === 'Exercise') {
        item.img = value.attributes.ExerciseMobileImageUrl || '';
        item.title = value.attributes.ExerciseTitle;
        item.type = 'Награда за задание';
        item.coins = Math.round(value.attributes.Amount);
        item.exerciseId = value.sourceId;
        item.operationSourceId = value.attributes.OperationSourceId;
        item.link = `/tasks/completed#!showTask=${value.sourceId}&peId=${value.attributes.OperationSourceId}`;
        return item;
      }
      if (value.attributes.OperationSource === 'MarketProduct' && value.attributes.State === 'Accepted') {
        item.img = value.attributes.ProductMobileImageUrl;
        item.title = value.attributes.ProductName;
        item.type = 'Покупка за баллы';
        item.coins = -Math.round(value.attributes.Amount);
        item.link = '/my-settings/purchase-history';
        return item;
      }
      if (value.attributes.OperationSource === 'MarketProduct' && value.attributes.State === 'Cancelled') {
        item.img = value.attributes.ProductMobileImageUrl;
        item.title = value.attributes.ProductName;
        item.type = '<span class="entry__type_error">Операция не удалась</span>';
        item.coins = -Math.round(value.attributes.Amount);
        item.operationSourceId = value.operationSourceId;
        item.operationType = value.operationType;
        return item;
      }
      if (value.attributes.OperationSource === 'StepsInDay') {
        item.icon = 'steps';
        item.title = this.pluralizeSteps(Math.round(value.attributes.StepsCount));
        item.type = 'Ежедневная награда';
        item.coins = Math.round(value.attributes.Amount);
        return item;
      }
      item.img = '';
      item.title = value.attributes.OperationSource;
      item.type = value.attributes.OperationType;
      item.coins = Math.round(value.attributes.Amount);
      return item;
    },
    getAvatarImage(avatar) {
      if (!avatar) return '';
      if (!avatar.type) return '';
      if (avatar.type === 'custom') {
        return avatar.url || '';
      }
      const found = Avatars.filter((i) => i.id === avatar.type);
      if (found.length === 0) return '';
      return found[0].img || '';
    },
    processMenuItems() {
      for (let i = 0; i < this.headerProps.menu.length; i += 1) {
        if (typeof this.headerProps.menu[i].action === 'string') {
          this.headerProps.menu[i].action = this.replaceVariables(this.headerProps.menu[i].action);
        }
      }
      for (let i = 0; i < this.headerProps.menuHidden.length; i += 1) {
        if (typeof this.headerProps.menuHidden[i].action === 'string') {
          this.headerProps.menuHidden[i].action = this.replaceVariables(this.headerProps.menuHidden[i].action);
        }
      }
      for (let i = 0; i < this.headerProps.mobileMenu.length; i += 1) {
        if (typeof this.headerProps.mobileMenu[i].action === 'string') {
          this.headerProps.mobileMenu[i].action = this.replaceVariables(this.headerProps.mobileMenu[i].action);
        }
      }
    },
    replaceVariables(text) {
      if (!text) return '';
      const vars = [
        { id: 'supportVK', value: this.supportVK },
        { id: 'menuUnauthorizedVK', value: this.menuUnauthorizedVK },
        { id: 'supportReglament', value: this.supportReglament },
      ];
      let result = text;
      for (let i = 0; i < vars.length; i += 1) {
        result = result.replaceAll(`{{${vars[i].id}}}`, vars[i].value);
      }
      return result;
    },
    processIsTeamRequired() {
      if (!this.isInternalPage) return;
      if (!this.profile || Object.keys(this.profile).length === 0 || !this.themeDone) return;
      if (!this.isTeamsEnabled || !this.isTeamStepRequired) return;
      // На мобильном приложении ждём загрузки ответов анкеты, чтобы не редиректить преждевременно
      if (this.isMobileApp && (!this.questionnaire || !this.questionnaire.answers)) return;
      if (this.questionnaire && Object.keys(this.questionnaire).length > 0) {
        const IsUnionMember = this.getAnswerByKey('IsUnionMember');
        if ((IsUnionMember === 'true' || IsUnionMember === '') && !this.isTeamSet) {
          this.$router.push({ name: 'Team', query: this.isMobileApp ? { title: 'Команда' } : {} }).catch(() => {});
        }
      } else {
        this.getQuestionnaire()
          .then(() => {
            if (this.questionnaireStatus === 200) {
              const IsUnionMember = this.getAnswerByKey('IsUnionMember');
              if ((IsUnionMember === 'true' || IsUnionMember === '') && !this.isTeamSet) {
                this.$router.push({ name: 'Team', query: this.isMobileApp ? { title: 'Команда' } : {} }).catch(() => {});
              }
            }
          });
      }
    },
    getAnswerByKey(key) {
      if (!this.questionnaire.answers || !key) return '';
      const found = this.questionnaire.answers.filter((i) => i.key === key);
      if (found.length === 0) return '';
      return found[0].value;
    },
    saveTeamInvitation() {
      const { t } = this.$route.query;
      if (t) {
        if (Base64.isValid(t)) {
          sessionStorage.setItem('invitationTeamId', Base64.decode(t));
        }
      }
    },
    saveParams() {
      const { ref, code } = this.$route.query;
      if (ref) {
        if (Base64.isValid(ref)) {
          sessionStorage.setItem('ref', Base64.decode(ref));
        }
      }
      if (code) {
        sessionStorage.setItem('marketingProgramCode', code);
      }
    },
    checkForMobile() {
      const isMobileApp = Cookies.get('fromMobileApp') === 'true';
      this.setIsMobileApp({ value: isMobileApp });
      if (!this.checkAppUrl || !this.isMobileOS || this.isMobileApp) return;
      const appChecked = sessionStorage.getItem('appCheckedForMobile') === 'true';
      if (appChecked) return;
      const { loginReturnUrl } = this.$route.query;
      let backURL = '';
      if (loginReturnUrl) {
        backURL = this.removeProtoFromURL(loginReturnUrl);
      } else {
        backURL = window.location.href;
        backURL = backURL.slice(window.location.protocol.length + 2);
      }
      const secureProto = 'https://';
      const hasProtoInCheckApp = this.checkAppUrl.indexOf(secureProto) === 0;
      window.location.href = `${!hasProtoInCheckApp ? secureProto : ''}${this.checkAppUrl}/url=${encodeURIComponent(backURL)}`;
    },
    removeProtoFromURL(url) {
      const index = url.indexOf('//');
      if (index !== -1 && index + 2 <= url.length - 1) return url.slice(url.indexOf('//') + 2);
      return url;
    },
    saveDeviceId() {
      if (!this.isMobileApp) return;
      const deviceId = Cookies.get('deviceId');
      if (!deviceId) return;
      this.setDeviceId({ value: deviceId });
    },
    checkForCode() {
      if (this.marketingProgramCode) {
        sessionStorage.setItem('marketingProgramCode', this.marketingProgramCode);
      }
    },
    initUserback() {
      if (!this.isFeedbackEnabled) return;

      const id = 'userback-sdk';
      const created = document.getElementById(id);
      if (created !== null) {
        return;
      }
      const s = document.createElement('script');
      s.onload = () => {
        window.Userback.init('A-8JKkhdf7f0dN5GxQG49YWEUMswJQ3S8bwtEzKNSNcXvaEH4r15', {
          widget_settings: {
            autohide: true,
            language: 'ru',
          },
        });
        this.footerFeedback = {
          icon: 'feedback',
          text: 'Отзыв о Программе',
        };
      };
      s.id = id;
      s.src = 'https://static.userback.io/widget/v1.js';
      const parentNode = document.head || document.body;
      parentNode.appendChild(s);
    },
    getDeviceSession() {
      if (this.profile && this.profile.participantId) {
        this.hasDeviceSession({ participantId: this.profile.participantId })
          .then(() => {
            this.setBannerMobile();
          });
      }
    },
    goPage(name, path) {
      if (!path) return;
      const params = { path };
      if (name != null) {
        params.name = name;
      }
      this.$router.push({ path: '/goPage', query: params }).catch(() => {});
    },
    openInExternal(url, returnPath = '') {
      if (!url) return;
      this.$router.push({ path: `/openInExternal?url=${url}&returnPath=${returnPath}` }).catch(() => {});
    },
    setLocationHash(hash) {
      // Получить query, удалить там параметр addToHistory без потери других параметров и перезагрузки страницы.
      const query = { ...this.$route.query };
      delete query.addToHistory;
      this.$router.replace({ query }).catch(() => {});
      window.location.hash = hash;
    },
  },
  created() {
    this.$root.isMobile = false;
    this.$root.isTablet = false;
    this.$root.isDesktop = false;
    Vue.prototype.$changeLang = this.changeLang;
    this.$root.$goPage = this.goPage;
    this.$root.$openInExternal = this.openInExternal;
    this.$root.$setLocationHash = this.setLocationHash;
    this.$root.$openInstallMobileModal = () => this.installMobileModalOpen();
  },
  mounted() {
    if (this.setCookieFromMobileApp) {
      Cookies.set('fromMobileApp', 'true', { expires: 365 });
      if (this.$route.query.token) Cookies.set('token', this.$route.query.token, { expires: 365 });
      const query = { ...this.$route.query };
      delete query.setCookieFromMobileApp;
      delete query.token;
      this.$router.replace({ query });
    }
    this.getRule();
    this.getIntroSections();
    this.getArticles();
    window.addEventListener('resize', this.onResize);
    this.onResize();
    this.loadSettings();
    this.checkForCode();
    this.generateInstallMobileQrCode();
    if (this.themeDone) {
      this.checkForMobile();
      this.saveDeviceId();
      this.saveTeamInvitation();
      this.saveParams();
      this.processMenuItems();
      this.setBannerMobile();
      setTimeout(() => { this.processIsTeamRequired(); }, 250);
      setTimeout(() => { this.initUserback(); }, 1000);
    }
    this.showMobileMigrationModalIfNeeded();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  :global(html), :global(body) {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .layout {
    min-height: 100vh;

    &_full-height {
      min-height: 100vh;
    }

    ::v-deep .rr-modal .rr-modal__subtitle a,
    ::v-deep .rr-modal .rr-modal__subtitle a:link,
    ::v-deep .rr-modal .rr-modal__subtitle a:hover,
    ::v-deep .rr-modal .rr-modal__subtitle a:active,
    ::v-deep .rr-modal .rr-modal__subtitle a:visited {
      text-decoration: none;
      color: var(--color-primary, #FF8233);
    }
    ::v-deep .rr-modal .rr-modal__subtitle span {
      color: var(--color-primary, #FF8233);
      font-weight: 600;
    }
    ::v-deep .rr-modal__window {
      border-radius: 8px;
    }
  }

  .scount-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    ::v-deep .scount-layout__container,
    ::v-deep .scount-layout__wrapper {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }

    ::v-deep .header-container {
      position: relative;
      height: 56px;

      @media (min-width: breakpoint(md)) {
        height: 64px;
      }

      @media (min-width: breakpoint(xl)) {
        height: 72px;
      }
    }

    ::v-deep .header__notification-button {
      display: none;
    }

    ::v-deep .header > .menu .menu__body {
      display: flex;
      flex-wrap: wrap;
      padding: 16px 28px 32px;
    }

    ::v-deep .header > .menu .menu__item {
      width: 100%;
    }

    ::v-deep .header > .menu .menu__link {
      padding-right: 4px;
      padding-left: 4px;
      font-weight: 700;
    }

    ::v-deep .header > .menu .menu__item:has(.mobile-menu-store) {
      width: auto;
      margin-top: 8px;
      margin-right: 16px;
    }

    ::v-deep .header > .menu .menu__item:has(.mobile-menu-store) .menu__link {
      padding: 0;
    }

    ::v-deep .header > .menu .mobile-menu-store {
      display: block;
      height: 40px;
    }

    ::v-deep #appFooterContainer {
      margin-top: auto;
    }
  }
  ::v-deep .entry__text {
      min-width: 0;
    }
  ::v-deep .entry__coins{
    max-width: 100%;
  }
  .mobile-migration-modal {
    ::v-deep .rr-modal__window {
      max-width: 484px;
      border-radius: 8px;
    }

    ::v-deep .rr-modal__container {
      padding: 52px 32px 48px;
    }

    ::v-deep .rr-modal__item {
      margin-top: 0;
    }
  }

  .mobile-migration {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &__logo {
      display: block;
      width: 48px;
      height: 48px;
      margin-bottom: 24px;
      object-fit: contain;
    }

    &__title {
      margin: 0 0 20px;
      color: $color-black;
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
    }

    &__subtitle {
      margin: 0 0 28px;
      color: rgba(0, 0, 0, 0.56);
      font-size: 16px;
      line-height: 24px;
    }

    &__bonus {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 32px;
      color: $color-black;
      font-size: 16px;
      line-height: 24px;

      img {
        width: 16px;
        height: 16px;
      }
    }

    &__button {
      position: relative;
      min-width: 280px;
      min-height: 48px;
      margin-bottom: 24px;
      padding: 0 24px;
      border: 0;
      border-radius: 4px;
      background: var(--color-primary, #FF7E57);
      color: $color-white;
      font-family: inherit;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      cursor: pointer;
    }

    &__skip {
      padding: 0;
      border: 0;
      background: transparent;
      color: rgba(0, 0, 0, 0.56);
      font-family: inherit;
      font-size: 13px;
      line-height: 18px;
      cursor: pointer;
    }
  }

  .modal-qrcode {
    &__img {
      display: block;
      width: 196px;
      height: 196px;
      margin: 0 auto 24px;

      @media (max-width: breakpoint(md)) {
        display: none;
      }
    }
    &__text {
      margin: 0 0 24px;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: rgba(0, 0, 0, 0.72);

      @media (max-width: breakpoint(md)) {
        display: none;
      }
    }
    &__items {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;

      @media (max-width: breakpoint(md)) {
        flex-direction: column;
      }
    }
    &__item-img {
      display: block;
      height: 48px;
    }
    &__list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      list-style: none;
      padding-top: 50px;
      padding-bottom: 20px;
      &-item {
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
        span {
          font-weight: 600;
        }
        svg {
          min-width: 32px;
          width: 32px;
          height: 32px;
          color: var(--color-primary, #FF8233);
        }
      }
      &-body {
        text-align: left;
        padding-left: 16px;
      }
    }
  }
  ::v-deep .entry__type_error {
    color: rgba(237, 28, 36, 1);
    font-weight: 600;
  }
</style>
